"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Skeleton = ({
  circle = false,
  height = undefined,
  width = undefined,
  rectangle = false,
  borderRadius = undefined
}) => {
  const commonProps = {
    height,
    width,
    'aria-hidden': true,
    role: 'presentation'
  };
  if (circle) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SkeletonCircle, {
      "data-testid": "skeleton",
      ...commonProps
    });
  }
  if (rectangle) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SkeletonRectangle, {
      "data-testid": "skeleton",
      borderRadius: borderRadius,
      ...commonProps
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SkeletonRow, {
    "data-testid": "skeleton",
    ...commonProps
  });
};
var _default = exports.default = Skeleton;